import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  ClipboardService,
  IButtonDirective,
  ICheckboxComponent,
  IIconComponent,
  ITooltipDirective,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AsinSelectionProduct } from "@m19-board/shared/asin-selection/asin-selection.component";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-asin-selection-row",
  imports: [
    CommonModule,
    ICheckboxComponent,
    IButtonDirective,
    ITooltipDirective,
    TranslocoDirective,
    RouterModule,
    IIconComponent,
  ],
  templateUrl: "./asin-selection-row.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsinSelectionRowComponent {
  private readonly clipboardService = inject(ClipboardService);

  product = input.required<AsinSelectionProduct>();
  readonly = input<boolean>(false);
  groupByParentAsin = input<boolean>(false);
  openedParentAsin = input<string>();
  asinsLimitReached = input<boolean>(true);
  asinsLimit = input.required<number>();

  productClicked = output<void>();
  openParentAsinClicked = output<string>();
  readonly restoreToManagedCatalogClicked = output<string>();

  onProductClick() {
    this.productClicked.emit();
  }

  openParentAsin() {
    this.openParentAsinClicked.emit(this.product().asin);
  }

  copyAsin() {
    this.clipboardService.copyToClipboard(this.product().asin);
  }

  restoreToManagedCatalog() {
    this.restoreToManagedCatalogClicked.emit(this.product().asin);
  }
}
